import "./cloudScanner.css";

export default function CloudScanner({ closing = false }) {
  return (
    <div className={`cloud-scanner-panel ${closing ? "scanner-closing" : ""}`}>
      <div className="cloud-scanner-panel-content">
        <main></main>
        <aside></aside>
      </div>
    </div>
  );
}
